import { Link } from 'react-router-dom';
import { INSTAGRAM_TAROMANCE_URL, NAVER_MAP_TAROMANCE_URL } from '../lib/externalLinks';
import { BRAND } from '../lib/brand';
import { BrandLogo } from './BrandLogo';

export function SiteFooter() {
  return (
    <footer className="tm-footer">
      <div className="tm-container">
        <div className="tm-footer-grid">
          <div className="tm-footer-brand">
            <Link to="/" className="tm-logo" aria-label="타로맨스 홈">
              <BrandLogo />
            </Link>
            <p>
              {BRAND.since}년부터 이어온 국내 최초 타로상담바.
              <br />
              타로 상담과 시그니처 칵테일, 깊이 있는 대화가 머무는 강남의 문화 바입니다.
            </p>
            <div className="tm-biz">
              <strong>{BRAND.nameKo}</strong>
              <br />
              대표 {BRAND.owner} · 사업자등록번호 {BRAND.bizNumber}
              <br />
              ({BRAND.postalCode}) {BRAND.address}
              <br />
              <a href={BRAND.phoneLink}>{BRAND.phoneDisplay}</a> · <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a>
            </div>
          </div>
          <div>
            <h4>Services</h4>
            <div className="tm-footer-col">
              <Link to="/tarot-consultation">타로 상담</Link>
              <Link to="/cocktail-menu">칵테일 & 메뉴</Link>
              <Link to="/night-community">나이트 커뮤니티</Link>
              <Link to="/education-consulting">클래스 & 컨설팅</Link>
              <Link to="/archive">아카이브</Link>
            </div>
          </div>
          <div>
            <h4>Visit</h4>
            <div className="tm-footer-col">
              <Link to="/visit">오시는 길</Link>
              <Link to="/reserve">예약 안내</Link>
              <a href={NAVER_MAP_TAROMANCE_URL} target="_blank" rel="noreferrer">네이버 지도</a>
            </div>
          </div>
          <div>
            <h4>Contact</h4>
            <div className="tm-footer-col">
              <a href={BRAND.phoneLink}>{BRAND.phoneDisplay}</a>
              <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a>
              <a href={INSTAGRAM_TAROMANCE_URL} target="_blank" rel="noreferrer">Instagram</a>
            </div>
          </div>
        </div>
        <div className="tm-footer-bottom">
          <span>© 2026 TAROMANCE. TAROT COUNSELING BAR.</span>
          <span>{BRAND.hours.label} {BRAND.hours.time}</span>
        </div>
      </div>
    </footer>
  );
}
